import { EntryPoint } from "../../../types/entrypoint";
import { getJSON } from "./digipost-fetch";

export async function getInitialState(): Promise<EntryPoint> {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const backendJSON = await getJSON<any>("/post/api");

  return {
    rootLinks: backendJSON.link,
    validationRules: backendJSON.validationRules,
    csrfToken: backendJSON.csrfToken,
  };
}
